import type { HTMLAttributes, ReactNode } from 'react';

/**
 * Carte — refonte « Nourri ».
 *
 * *Le* conteneur du système : fond de surface, rayon `--radius-lg`, et la
 * seule ombre que la palette définit. Le prototype en décline quatre —
 * `.card`, `.summary-card`, `.meal-card`, `.list-card` — qui ne diffèrent que
 * par leur rembourrage.
 *
 * | Prototype       | Ici                  |
 * |-----------------|----------------------|
 * | `.card`         | `padding="md"`       |
 * | `.summary-card` | `padding="lg"`       |
 * | `.meal-card`    | `padding="none"`     |
 * | `.list-card`    | `padding="none"`     |
 *
 * ⚠️ **`padding="none"` n'est pas « sans marge »**, c'est « la gouttière
 * appartient au contenu ». Une carte qui porte des lignes de liste doit les
 * laisser toucher ses deux bords, sans quoi ni leurs séparateurs ni leur fond
 * au contact n'iront jusqu'au rayon.
 *
 * ⚠️ La carte ne réagit à aucun geste, délibérément : quand elle est
 * cliquable, c'est une ligne à l'intérieur qui l'est. Une carte entière qui
 * s'allume au contact ferait croire qu'un tap n'importe où fait la même chose.
 */
export function Card({
  children,
  padding = 'md',
  className,
  ...rest
}: {
  children: ReactNode;
  padding?: 'none' | 'md' | 'lg';
} & Omit<HTMLAttributes<HTMLDivElement>, 'className'> & { className?: string }) {
  const classes = ['n-card'];
  if (padding !== 'none') classes.push(`n-card--${padding}`);
  if (className) classes.push(className);

  return (
    <div className={classes.join(' ')} {...rest}>
      {children}
    </div>
  );
}
